import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../../../redux/store.model';
import { getRightUserUtilSelector } from '../../../redux/rights/selectors';
import { getMyWorkspaceSelector } from '../../../redux/stoerkID/selectors/StoerkId.selectors';

/**
 * InvitationsGuard component
 * This guard checks if a user has the right to see invitations (canSeeInvitations permission).
 * If the user has the permission, it renders the child routes.
 * Otherwise, it redirects to the home page ("/").
 */
function InvitationsGuard() {
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);
  const rightsUserUtil = useAppSelector(getRightUserUtilSelector);
  const canSeeInvitations = rightsUserUtil.canSeeInvitationsPage(
    myWorkspace?.id ?? ''
  );

  return canSeeInvitations ? <Outlet /> : <Navigate to="/" replace />;
}

export default InvitationsGuard;
